import { ReactComponent as SvgClear } from '@img/icons/clear.svg';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './ClearButton.styles';
const ClearButton = ({ label, ...props }) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { ...props },
            React.createElement(S.Icon, { as: SvgClear }),
            React.createElement(S.Text, null, label ? label : 'Clear All'))));
};
export default ClearButton;
